import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const FullSizeControlPanelWrapper = styled.div`
  width: 100%;
  height: 100vh;

  overflow: auto;

  display: flex;
  flex-direction: column;

  padding: 20px;

  background: ${theme.colors.SurfaceRaisinBlack50};
`;
